import type { WalletAccount } from '@dynamic-labs-sdk/client';

import type { BitcoinWalletAccount } from '../BitcoinWalletAccount.types';

/**
 * Type guard function to check if a wallet account is a Bitcoin wallet account.
 *
 * @param walletAccount - The wallet account to check.
 * @returns True if the wallet account is a Bitcoin wallet account, false otherwise.
 */
export const isBitcoinWalletAccount = (
  walletAccount: WalletAccount
): walletAccount is BitcoinWalletAccount => walletAccount.chain === 'BTC';
